import axios from 'axios'
import { baseUrl } from '@/api/config'
// 查询租户领域id
export function getDomainId(params) {
  const url = baseUrl + '/tenant/qa/domain'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

// 查询领域列表
export function domainList(params) {
  const url = baseUrl + '/tenant/qa/domain/list'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

// 更新租户领域
export function domainUpdate(params) {
  const url = baseUrl + '/tenant/qa/domain/update'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

// 查询书籍列表
export function bookList(params) {
  const url = baseUrl + '/tenant/qa/book/list'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

// 更新机构关连书籍
export function bookUpdate(params) {
  const url = baseUrl + '/tenant/qa/book/update'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

// 查询租户已配置机构对应数据
export function ouBookPage(params) {
  const url = baseUrl + '/tenant/qa/ou/book/page'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
